<script setup lang="ts">
import { type PageCardProps } from '#ui/types';

export interface StoryblokFleequidStatsProps {
    blok: StoryblokFleequidStats;
}

// PROPS
const { blok } = defineProps<StoryblokFleequidStatsProps>();

// COMPOSABLES
const { tt, tn } = useTypedI18n();
const { soldVehicles, countries, companies, employees } = useFleequidStats();

// DATA
const items = computed<PageCardProps[]>(() => [
    {
        title: tn(soldVehicles.value),
        description: tt('storyblok.stats.purchase'),
    },
    {
        title: tn(countries.value),
        description: tt('storyblok.stats.markets'),
    },
    {
        title: tn(employees.value),
        description: tt('storyblok.stats.team'),
    },
    {
        title: tn(companies.value),
        description: tt('storyblok.stats.registrations'),
    },
]);
const itemUi = {
    root: 'rounded-xl',
    title: 'text-3xl text-center font-bold',
    wrapper: 'items-center justify-center',
};
const ui = {
    features: 'lg:grid-cols-4',
};
</script>

<template>
    <UPageSection v-editable="blok" :ui="ui" :title="blok?.title ?? tt('storyblok.stats.title')" :headline="blok?.headline">
        <template #features>
            <UPageCard v-for="item in items" :key="item.title" variant="outline" v-bind="item" :ui="itemUi" />
        </template>
    </UPageSection>
</template>
